import React from 'react';
import { useSYS4110_R01Store } from './Store_SYS4110_R01';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';

interface SearchSectionProps {
  onCreateButtonClick: () => void;
  onCompCdChange?: (compCd: string) => void;
  defaultCompCd?: string;
}

// 사업장 선택 드롭다운 컴포넌트
interface CompanyDropdownProps {
  onCompCdChange?: (compCd: string) => void;
  defaultCompCd?: string;
}

const CompanyDropdown: React.FC<CompanyDropdownProps> = ({ onCompCdChange, defaultCompCd }) => {
  const { compCdList } = useCommonCodeStore();

  return (
    <div className="flex items-center gap-2">
      <label className="text-sm font-medium text-gray-700">사업장:</label>
      <select
        className="px-3 py-1 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        onChange={(e) => onCompCdChange?.(e.target.value)}
        value={defaultCompCd || ''}
      >
        {compCdList.map((comp) => (
          <option key={comp.compCd} value={comp.compCd}>
            {comp.compNm}
          </option>
        ))}
      </select>
    </div>
  );
};

// 일정 등록 버튼 컴포넌트
interface CreateButtonProps {
  onClick: () => void;
}

const CreateButton: React.FC<CreateButtonProps> = ({ onClick }) => (
  <button
    onClick={onClick}
    className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors flex items-center gap-2"
  >
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
    일정 등록
  </button>
);

// 오늘 버튼 컴포넌트
interface TodayButtonProps {
  onClick: () => void;
}

const TodayButton: React.FC<TodayButtonProps> = ({ onClick }) => (
  <button
    onClick={onClick}
    className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors flex items-center gap-2"
  >
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
    </svg>
    오늘
  </button>
);

export const SearchSection_SYS4110_R01: React.FC<SearchSectionProps> = ({
  onCreateButtonClick,
  onCompCdChange,
  defaultCompCd
}) => {
  const { navigateToToday, setSelectedDate } = useSYS4110_R01Store();

  const handleTodayClick = () => {
    const today = new Date();
    navigateToToday();  // 현재 월로 이동
    setSelectedDate(today);  // 오늘 날짜 선택
  };

  return (
    <div className="flex items-center justify-between pl-4 pr-4 pt-2 bg-white">
      <div className="flex items-center gap-4">
        <CompanyDropdown onCompCdChange={onCompCdChange} defaultCompCd={defaultCompCd} />
      </div>
      <div className="flex items-center gap-2">
        <TodayButton onClick={handleTodayClick} />
        <CreateButton onClick={onCreateButtonClick} />
      </div>
    </div>
  );
}; 